/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */

/**
 * Created by seaster on 3/30/16.
 */
'use strict';
angular.module('prism-ui.package').controller('SelectMasterMediaTypesModalController', function ($uibModalInstance) {
	var self = this;

	self.selectedContent = {
		'Video': true,
		'Audio': true,
		'CC': true,
		'Subtitle': true,
		'Image': true
	};

	self.toggleContent = function (contentType) {
		if(self.selectedContent[contentType]) {
			delete self.selectedContent[contentType];
		} else {
			self.selectedContent[contentType] = true;
		}
	};

	self.onOk = function () {
		$uibModalInstance.close(self.selectedContent);
	};

	self.cancel = function () {
		$uibModalInstance.dismiss('cancel');
	};

	self.disableOKButton = function () {
		return Object.keys(self.selectedContent).length === 0;
	};
});
